import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { highlightConfig, tokens } from '../../constants';
export var getHighlightStyles = props => {
  var _a, _b, _c, _d, _e;
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'under-card' : _props$variant,
    config = props.config;
  var borderRadius = config === null || config === void 0 ? void 0 : config[variant];
  var _borderBottomLeftRadius = borderRadius.borderBottomLeftRadius,
    _borderBottomRightRadius = borderRadius.borderBottomRightRadius,
    _borderTopLeftRadius = borderRadius.borderTopLeftRadius,
    _borderTopRightRadius = borderRadius.borderTopRightRadius,
    _borderRadius = borderRadius.borderRadius;
  var highlightBorderRadius = {
    borderBottomLeftRadius: (_a = tokens.borderRadius) === null || _a === void 0 ? void 0 : _a[_borderBottomLeftRadius],
    borderBottomRightRadius: (_b = tokens.borderRadius) === null || _b === void 0 ? void 0 : _b[_borderBottomRightRadius],
    borderTopLeftRadius: (_c = tokens.borderRadius) === null || _c === void 0 ? void 0 : _c[_borderTopLeftRadius],
    borderTopRightRadius: (_d = tokens.borderRadius) === null || _d === void 0 ? void 0 : _d[_borderTopRightRadius],
    borderRadius: (_e = tokens.borderRadius) === null || _e === void 0 ? void 0 : _e[_borderRadius]
  };
  return StyleSheet.create({
    container: {
      padding: tokens.spacing.SPACING_1,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_32,
      width: '100%'
    },
    innerContainer: Object.assign(Object.assign({
      width: '100%',
      paddingHorizontal: tokens.spacing.SPACING_12,
      paddingVertical: tokens.spacing.SPACING_8
    }, highlightBorderRadius), {
      flexDirection: 'row',
      alignItems: 'center'
    }),
    text: {
      marginLeft: tokens.spacing.SPACING_8,
      flex: 1
    },
    iconContainer: {
      position: 'relative'
    },
    offerIcon: {
      position: 'absolute',
      left: tokens.spacing.SPACING_7,
      top: tokens.spacing.SPACING_7
    },
    logoGroupContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start'
    },
    logoGroupIconStyle: {
      marginLeft: -tokens.spacing.SPACING_8
    }
  });
};
export var getHighlightProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(highlightConfig === null || highlightConfig === void 0 ? void 0 : highlightConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.highlight) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};